import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoComments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.09 2.27L4.09 0.27H18.89C20 0.27 20.89 1.17 20.89 2.27V14.27C20.89 15.03 20.46 15.68 19.84 16.02L18.09 14.27H18.89V2.27H6.09ZM21 19.73L19.73 21L15 16.27H12.79L9.09 19.98C8.89 20.17 8.64 20.27 8.39 20.27H7.89C7.34 20.27 6.89 19.82 6.89 19.27V16.27H2.89C1.79 16.27 0.89 15.38 0.89 14.27V2.17L0 1.27L1.28 0L21 19.73ZM13 14.27L2.89 4.16V14.27H8.89V17.35L11.97 14.27H13Z",
		fill: "#C6CDD2"
	})
});
export default SvgNoComments;
